const C = require("../constants");

const openModalIngredientStockUpdate = modal => {
    return {
        type: C.INGREDIENT_STOCK_UPDATE_MODAL,
        modal
    }
};

export {openModalIngredientStockUpdate};


// WEBPACK FOOTER //
// ./src/actions/ModalIngredientStockUpdateActions.js